import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ElementoMenu, GestionMenu } from './elemento-menu';
import { ObtenerMenuService } from './obtener-menu.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MenuComponent implements OnInit {
  public elementosMenu = [] as ElementoMenu[];
  public rutaActual: string = '';
  public panelMenuAbierto: boolean = false;
  public menuActivo: ElementoMenu | null = null;
  @Output() opcionMenuActiva = new EventEmitter<GestionMenu>();

  constructor(
    private router: Router,
    private obtenerMenuService: ObtenerMenuService,
  ) {}

  public ngOnInit(): void {
    this.rutaActual = this.router.url;
    this.obtenerMenu();
    this.router.events.subscribe((event) => {
      this.rutaActual = this.router.url;
    });
  }

  public rutaVisible(elementoMenu: ElementoMenu): boolean {
    if (elementoMenu.elementosHijos.length > 0) {
      elementoMenu.activo = elementoMenu.elementosHijos.some(
        (hijo) => hijo.ruta === this.rutaActual,
      );
    } else {
      elementoMenu.activo = elementoMenu.ruta === this.rutaActual;
    }
    return elementoMenu.activo;
  }

  private obtenerMenu(): void {
    this.obtenerMenuService.__invoke().subscribe({
      next: (elementos) => {
        this.elementosMenu = elementos;
      },
    });
  }

  abrirPanelMenuONavegar(item: ElementoMenu) {
    if (item.elementosHijos.length !== 0) {
      this.menuActivo === item
        ? this.cerrarPanelMenu()
        : this.abrirPanelMenu(item);
    } else {
      if (item.ruta) this.router.navigate([item.ruta]);
      this.cerrarPanelMenu();
    }
  }

  private abrirPanelMenu(item: ElementoMenu) {
    this.menuActivo = item;
    this.panelMenuAbierto = true;
    this.opcionMenuActiva.emit({ opcion: item, abierto: true });
  }

  cerrarPanelMenu() {
    this.menuActivo = null;
    this.panelMenuAbierto = false;
    this.opcionMenuActiva.emit({ opcion: null, abierto: false });
  }
}
